import React, { ReactNode } from "react";
import { Box } from "@mui/material";

interface CardHeadingProps {
  title: ReactNode;
  actions: ReactNode;
  actionsInline?: boolean;
}

export const CardHeading = ({
  title,
  actions,
  actionsInline = false,
}: CardHeadingProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      width="100%"
      gap={2}
      mb={2.5}
    >
      <Box
        display="flex"
        flexDirection={actionsInline ? "row" : { xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "flex-start" }}
        justifyContent={
          actionsInline ? "space-between" : { md: "space-between" }
        }
        gap={2}
        width="100%"
      >
        {title}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap={2}
          flexShrink={0}
        >
          {actions}
        </Box>
      </Box>
    </Box>
  );
};
